import React, { useCallback } from 'react';
import Icon from '@vtblife/uikit-icons';

import styles from './chat-list-button.module.css';

interface IChatButtonProps {
    openChat: () => void;
}

export const ChatListButton = ({ openChat }: IChatButtonProps) => {
    const openPopup = useCallback(() => {
        window.dataLayer.push({
            event: 'lk_action',
            page_type: 'lk',
            section: 'all',
            type: 'deals_chats',
        });
        openChat();
    }, [openChat]);

    return (
        <>
            <div data-test="chat-list-button" className="chatListButton" onClick={openPopup} data-gtm="bank-chat-stub">
                <div className={styles.icon}>
                    <Icon name="m2-chat" />
                </div>
                <div className={styles.text}>Чаты по сделкам</div>
            </div>
        </>
    );
};
